import { render, staticRenderFns } from "./smart_aspiration.vue?vue&type=template&id=f50cc12c&scoped=true"
import script from "./smart_aspiration.vue?vue&type=script&lang=js"
export * from "./smart_aspiration.vue?vue&type=script&lang=js"
import style0 from "./smart_aspiration.vue?vue&type=style&index=0&id=f50cc12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50cc12c",
  null
  
)

export default component.exports